import Create from "./Create";
import Edit from "./Edit";
import { EventNotifierIcon } from "../icons";
import List from "./List";

export default {
  options: {
    group: "config",
    accessible: ({ user }) =>
      user.role === "admin" &&
      user.permissions.indexOf("event-notifier/list") !== -1,
  },
  icon: EventNotifierIcon,
  list: List,
  edit: Edit,
  create: Create,
};
